import React from 'react';
import { Card, Typography, Row, Col, Button, Divider } from 'antd';

const { Title, Text } = Typography;

interface TestingGuideCardProps {
  onQuickImpersonate: (email: string) => void;
}

export const TestingGuideCard: React.FC<TestingGuideCardProps> = ({
  onQuickImpersonate,
}) => {
  const TestingSection = ({
    title,
    titleColor,
    points,
    buttons,
  }: {
    title: string;
    titleColor: string;
    points: string[];
    buttons: Array<{ label: string; email: string; color?: string }>;
  }) => (
    <div>
      <Title level={5} className={titleColor}>
        {title}
      </Title>
      <div className="mb-4 space-y-1">
        {points.map((point, index) => (
          <Text key={index} className="block text-sm">
            • {point}
          </Text>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {buttons.map((button, index) => (
          <Button
            key={index}
            size="small"
            type={button.color === 'primary' ? 'default' : 'default'}
            className={
              button.color === 'error'
                ? 'border-red-500 text-red-500 hover:border-red-600 hover:text-red-600'
                : button.color === 'success'
                ? 'border-green-500 text-green-500 hover:border-green-600 hover:text-green-600'
                : 'border-blue-500 text-blue-500 hover:border-blue-600 hover:text-blue-600'
            }
            onClick={() => onQuickImpersonate(button.email)}
          >
            {button.label}
          </Button>
        ))}
      </div>
    </div>
  );

  return (
    <Card>
      <Title level={4} className="mb-4">Testing Guide</Title>
      <Divider className="mt-0" />

      <Row gutter={[24, 24]}>
        <Col xs={24} md={8}>
          <TestingSection
            title="Company Admin Testing"
            titleColor="text-red-500"
            points={[
              'View all regions and all jobs',
              'Access all customers',
              'Export CSV from Jobs and Customers',
              'Delete customers',
              'Full settings access',
            ]}
            buttons={[
              {
                label: 'Test as Nick Evans (CEO)',
                email: 'nick.evans@victoriansliders.co.uk',
                color: 'error',
              },
            ]}
          />
        </Col>

        <Col xs={24} md={8}>
          <TestingSection
            title="Analytics Testing"
            titleColor="text-blue-500"
            points={[
              'View assigned regions only',
              'See regional jobs and customers',
              'Export CSV data',
              'Edit customers (not delete)',
              'Account settings only',
            ]}
            buttons={[
              {
                label: 'Test as Heather Guitar (Marketing)',
                email: 'heather.guitar@victoriansliders.co.uk',
                color: 'primary',
              },
              {
                label: 'Test as James (Scotland only)',
                email: 'james.mcgregor@victoriansliders.co.uk',
                color: 'primary',
              },
            ]}
          />
        </Col>

        <Col xs={24} md={8}>
          <TestingSection
            title="Customer Testing"
            titleColor="text-green-500"
            points={[
              'View own jobs only',
              'No customer list access',
              'No CSV export',
              'Limited navigation menu',
              'Account settings only',
            ]}
            buttons={[
              {
                label: 'Test as AB Windows',
                email: 'john.smith@abwindows.com',
                color: 'success',
              },
            ]}
          />
        </Col>
      </Row>
    </Card>
  );
};
